"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalFilesPanel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _closeButton = require("@design/ui/close-button");
var _hoverCard = require("@design/ui/hover-card");
var _fileUploadArea = require("@design-generated/file-upload-area");
var _fileUploadArea2 = require("@design-generated/file-upload-area.wiring");
var _artifactIcon = require("@common/utils/artifactIcon");
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _SavedFilesContext = require("../../context/SavedFilesContext");
var _AuthContext = require("../../context/AuthContext");
var _AddinArtifactThumbnail = require("../chat/AddinArtifactThumbnail");
var _ResourceSharePopover = require("../share/ResourceSharePopover");
var _Loader = _interopRequireDefault(require("@common/components/common/Loader"));
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _file = require("../../utils/file");
var _useLocalFilePicker2 = require("./hooks/use-local-file-picker");
var _useArtifacts2 = require("./hooks/use-artifacts");
var _useLocalFilesPanelSavedFiles = require("./hooks/use-local-files-panel-saved-files");
var _LocalFilesPanel = require("./LocalFilesPanel.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // Keep the file picker in sync with the attachment validator so users can't
// select files that are guaranteed to be rejected (see ChatContext.handleAddFiles).
var ATTACHMENT_ACCEPT = _file.ALLOWED_ATTACHMENT_EXTENSIONS.join(',');
var EMPTY_FILE_UPLOAD_AREA = {
  fileUploadAreaTitle: "Click to select files",
  fileUploadAreaText: "or drag and drop files here",
  button: {},
  kbd: {}
};
var ArtifactRowWithPreview = function ArtifactRowWithPreview(_ref) {
  var artifact = _ref.artifact,
    isUnread = _ref.isUnread,
    isFlashing = _ref.isFlashing,
    isDownloading = _ref.isDownloading,
    isDeleting = _ref.isDeleting,
    isPromoting = _ref.isPromoting,
    onArtifactClick = _ref.onArtifactClick,
    onDownloadArtifact = _ref.onDownloadArtifact,
    onDeleteArtifact = _ref.onDeleteArtifact,
    onPromoteArtifact = _ref.onPromoteArtifact;
  var canPromote = artifact.scope === "conversation" && !!onPromoteArtifact;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hoveringRow = _useState2[0],
    setHoveringRow = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hoveringActions = _useState4[0],
    setHoveringActions = _useState4[1];
  var showPreview = hoveringRow && !hoveringActions;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_hoverCard.HoverCard, {
    open: showPreview,
    "data-sentry-element": "HoverCard",
    "data-sentry-component": "ArtifactRowWithPreview",
    "data-sentry-source-file": "LocalFilesPanel.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverCard.HoverCardTrigger, {
      asChild: true,
      "data-sentry-element": "HoverCardTrigger",
      "data-sentry-source-file": "LocalFilesPanel.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.ArtifactItem, {
        title: artifact.description || artifact.name,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return onArtifactClick === null || onArtifactClick === void 0 ? void 0 : onArtifactClick(artifact.id);
        },
        onKeyDown: function onKeyDown(e) {
          // Action buttons (Download/Delete) live inside this row; Enter/Space
          // on those would bubble up here without this guard, double-firing.
          if (e.target !== e.currentTarget) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onArtifactClick === null || onArtifactClick === void 0 || onArtifactClick(artifact.id);
          }
        },
        onMouseEnter: function onMouseEnter() {
          return setHoveringRow(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setHoveringRow(false);
        },
        "data-sentry-element": "ArtifactItem",
        "data-sentry-source-file": "LocalFilesPanel.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactIcon, {
          "data-sentry-element": "ArtifactIcon",
          "data-sentry-source-file": "LocalFilesPanel.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_artifactIcon.ArtifactTypeIcon, {
            artifactType: artifact.type,
            width: 14,
            height: 14,
            "data-sentry-element": "ArtifactTypeIcon",
            "data-sentry-source-file": "LocalFilesPanel.tsx"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.ArtifactTextColumn, {
          "data-sentry-element": "ArtifactTextColumn",
          "data-sentry-source-file": "LocalFilesPanel.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactName, {
            "data-sentry-element": "ArtifactName",
            "data-sentry-source-file": "LocalFilesPanel.tsx",
            children: artifact.name
          }), artifact.description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactDescription, {
            children: artifact.description
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.ArtifactActions, {
          onMouseEnter: function onMouseEnter() {
            return setHoveringActions(true);
          },
          onMouseLeave: function onMouseLeave() {
            return setHoveringActions(false);
          },
          "data-sentry-element": "ArtifactActions",
          "data-sentry-source-file": "LocalFilesPanel.tsx",
          children: [isUnread && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactDot, {
            $flashing: isFlashing
          }), canPromote && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactActionButton, {
            onClick: function onClick(e) {
              e.stopPropagation();
              if (!isPromoting) onPromoteArtifact === null || onPromoteArtifact === void 0 || onPromoteArtifact(artifact);
            },
            disabled: isPromoting,
            title: isPromoting ? "Promoting…" : "Promote to workspace — shares this with anyone who has access to the workspace and moves it out of this chat into the workspace artifacts list",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ShareIcon, {
              width: 14,
              height: 14
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactActionButton, {
            onClick: function onClick(e) {
              e.stopPropagation();
              if (!isDownloading) onDownloadArtifact(artifact);
            },
            disabled: isDownloading,
            title: isDownloading ? "Downloading…" : "Download",
            "data-sentry-element": "ArtifactActionButton",
            "data-sentry-source-file": "LocalFilesPanel.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DownloadIcon, {
              width: 14,
              height: 14,
              "data-sentry-element": "DownloadIcon",
              "data-sentry-source-file": "LocalFilesPanel.tsx"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactActionButton, {
            onClick: function onClick(e) {
              e.stopPropagation();
              if (!isDeleting) onDeleteArtifact(artifact);
            },
            disabled: isDeleting,
            title: isDeleting ? "Deleting…" : "Delete artifact",
            "data-sentry-element": "ArtifactActionButton",
            "data-sentry-source-file": "LocalFilesPanel.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeleteIcon, {
              width: 14,
              height: 14,
              "data-sentry-element": "DeleteIcon",
              "data-sentry-source-file": "LocalFilesPanel.tsx"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverCard.HoverCardContent, {
      side: "top",
      align: "start",
      className: "w-auto",
      "data-sentry-element": "HoverCardContent",
      "data-sentry-source-file": "LocalFilesPanel.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddinArtifactThumbnail.AddinArtifactThumbnail, {
        artifactId: artifact.id,
        renderHeader: function renderHeader(a) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
            className: "text-gray-900",
            children: a.name
          });
        },
        "data-sentry-element": "AddinArtifactThumbnail",
        "data-sentry-source-file": "LocalFilesPanel.tsx"
      })
    })]
  });
};
var _ArtifactTreeView = function ArtifactTreeView(_ref2) {
  var node = _ref2.node,
    parentPath = _ref2.parentPath,
    collapsedFolders = _ref2.collapsedFolders,
    onToggleFolder = _ref2.onToggleFolder,
    recentArtifactIds = _ref2.recentArtifactIds,
    flashingArtifactIds = _ref2.flashingArtifactIds,
    onArtifactClick = _ref2.onArtifactClick,
    downloadingArtifactIds = _ref2.downloadingArtifactIds,
    onDownloadArtifact = _ref2.onDownloadArtifact,
    deletingArtifactIds = _ref2.deletingArtifactIds,
    onDeleteArtifact = _ref2.onDeleteArtifact,
    promotingArtifactIds = _ref2.promotingArtifactIds,
    onPromoteArtifact = _ref2.onPromoteArtifact;
  var folders = Array.from(node.children.entries()).sort(function (_ref3, _ref4) {
    var _ref5 = _slicedToArray(_ref3, 1),
      a = _ref5[0];
    var _ref6 = _slicedToArray(_ref4, 1),
      b = _ref6[0];
    return a.localeCompare(b);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [node.artifacts.map(function (artifact) {
      var _recentArtifactIds$ha, _flashingArtifactIds$;
      var isUnread = (_recentArtifactIds$ha = recentArtifactIds === null || recentArtifactIds === void 0 ? void 0 : recentArtifactIds.has(artifact.id)) !== null && _recentArtifactIds$ha !== void 0 ? _recentArtifactIds$ha : false;
      var isFlashing = (_flashingArtifactIds$ = flashingArtifactIds === null || flashingArtifactIds === void 0 ? void 0 : flashingArtifactIds.has(artifact.id)) !== null && _flashingArtifactIds$ !== void 0 ? _flashingArtifactIds$ : false;
      var isDownloading = downloadingArtifactIds.has(artifact.id);
      var isDeleting = deletingArtifactIds.has(artifact.id);
      var isPromoting = promotingArtifactIds.has(artifact.id);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ArtifactRowWithPreview, {
        artifact: artifact,
        isUnread: isUnread,
        isFlashing: isFlashing,
        isDownloading: isDownloading,
        isDeleting: isDeleting,
        isPromoting: isPromoting,
        onArtifactClick: onArtifactClick,
        onDownloadArtifact: onDownloadArtifact,
        onDeleteArtifact: onDeleteArtifact,
        onPromoteArtifact: onPromoteArtifact
      }, artifact.id);
    }), folders.map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        name = _ref8[0],
        child = _ref8[1];
      var folderPath = parentPath ? "".concat(parentPath, "/").concat(name) : name;
      var isCollapsed = collapsedFolders.has(folderPath);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FolderRow, {
          type: "button",
          onClick: function onClick() {
            return onToggleFolder(folderPath);
          },
          title: folderPath,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FolderChevron, {
            children: isCollapsed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
              width: 12,
              height: 12
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
              width: 12,
              height: 12
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.FolderIcon, {
            width: 12,
            height: 12
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: name
          })]
        }), !isCollapsed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FolderChildren, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArtifactTreeView, {
            node: child,
            parentPath: folderPath,
            collapsedFolders: collapsedFolders,
            onToggleFolder: onToggleFolder,
            recentArtifactIds: recentArtifactIds,
            flashingArtifactIds: flashingArtifactIds,
            onArtifactClick: onArtifactClick,
            downloadingArtifactIds: downloadingArtifactIds,
            onDownloadArtifact: onDownloadArtifact,
            deletingArtifactIds: deletingArtifactIds,
            onDeleteArtifact: onDeleteArtifact,
            promotingArtifactIds: promotingArtifactIds,
            onPromoteArtifact: onPromoteArtifact
          })
        })]
      }, "folder:".concat(folderPath));
    })]
  });
};
var LocalFilesPanel = exports.LocalFilesPanel = function LocalFilesPanel(_ref9) {
  var _user$hasManagePrompt;
  var onClose = _ref9.onClose,
    onFilesSelected = _ref9.onFilesSelected,
    onSelectSavedFile = _ref9.onSelectSavedFile,
    _ref9$selectedFiles = _ref9.selectedFiles,
    selectedFiles = _ref9$selectedFiles === void 0 ? [] : _ref9$selectedFiles,
    onRemoveFiles = _ref9.onRemoveFiles,
    onRemoveSavedFile = _ref9.onRemoveSavedFile,
    _ref9$artifacts = _ref9.artifacts,
    artifacts = _ref9$artifacts === void 0 ? [] : _ref9$artifacts,
    recentArtifactIds = _ref9.recentArtifactIds,
    flashingArtifactIds = _ref9.flashingArtifactIds,
    onArtifactClick = _ref9.onArtifactClick,
    onDeleteArtifact = _ref9.onDeleteArtifact,
    onPromoteArtifact = _ref9.onPromoteArtifact,
    _ref9$hasWorkspace = _ref9.hasWorkspace,
    hasWorkspace = _ref9$hasWorkspace === void 0 ? false : _ref9$hasWorkspace;
  var _useLocalFilePicker = (0, _useLocalFilePicker2.useLocalFilePicker)({
      onFilesSelected: onFilesSelected,
      onClose: onClose,
      onRemoveFiles: onRemoveFiles
    }),
    fileInputRef = _useLocalFilePicker.fileInputRef,
    handleFileSelect = _useLocalFilePicker.handleFileSelect,
    handleDrop = _useLocalFilePicker.handleDrop,
    handleDragOver = _useLocalFilePicker.handleDragOver,
    handleClick = _useLocalFilePicker.handleClick,
    handleRemoveFile = _useLocalFilePicker.handleRemoveFile;
  var _useSavedFiles = (0, _SavedFilesContext.useSavedFiles)(),
    files = _useSavedFiles.files,
    loading = _useSavedFiles.loading,
    createFile = _useSavedFiles.createFile,
    deleteFile = _useSavedFiles.deleteFile;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user;
  var canManageFiles = (_user$hasManagePrompt = user === null || user === void 0 ? void 0 : user.hasManagePromptsPermission) !== null && _user$hasManagePrompt !== void 0 ? _user$hasManagePrompt : false;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    fileShareTarget = _useState6[0],
    setFileShareTarget = _useState6[1];
  var _useLocalFilesPanelSa = (0, _useLocalFilesPanelSavedFiles.useLocalFilesPanelSavedFiles)({
      createFile: createFile,
      sendError: sendError,
      canManageFiles: canManageFiles,
      deleteFile: deleteFile,
      onSelectSavedFile: onSelectSavedFile,
      selectedFiles: selectedFiles,
      onRemoveSavedFile: onRemoveSavedFile
    }),
    uploadingFile = _useLocalFilesPanelSa.uploadingFile,
    showDeleteDialog = _useLocalFilesPanelSa.showDeleteDialog,
    fileToDelete = _useLocalFilesPanelSa.fileToDelete,
    addFileInputRef = _useLocalFilesPanelSa.addFileInputRef,
    handleAddFile = _useLocalFilesPanelSa.handleAddFile,
    handleAddFileSelect = _useLocalFilesPanelSa.handleAddFileSelect,
    isManagedFile = _useLocalFilesPanelSa.isManagedFile,
    handleDeleteFile = _useLocalFilesPanelSa.handleDeleteFile,
    handleDeleteConfirm = _useLocalFilesPanelSa.handleDeleteConfirm,
    handleDeleteCancel = _useLocalFilesPanelSa.handleDeleteCancel,
    handleDownloadFile = _useLocalFilesPanelSa.handleDownloadFile,
    handleSelectFile = _useLocalFilesPanelSa.handleSelectFile,
    isFileAttached = _useLocalFilesPanelSa.isFileAttached,
    handleRemoveSavedFile = _useLocalFilesPanelSa.handleRemoveSavedFile;
  var _useArtifacts = (0, _useArtifacts2.useArtifacts)({
      artifacts: artifacts,
      sendError: sendError,
      onPromoteArtifact: onPromoteArtifact,
      onDeleteArtifact: onDeleteArtifact
    }),
    downloadingArtifactIds = _useArtifacts.downloadingArtifactIds,
    deletingArtifactIds = _useArtifacts.deletingArtifactIds,
    collapsedArtifactFolderPaths = _useArtifacts.collapsedArtifactFolderPaths,
    artifactAwaitingDeleteConfirmation = _useArtifacts.artifactAwaitingDeleteConfirmation,
    promotingArtifactIds = _useArtifacts.promotingArtifactIds,
    workspaceArtifacts = _useArtifacts.workspaceArtifacts,
    chatExclusiveArtifacts = _useArtifacts.chatExclusiveArtifacts,
    workspaceArtifactTree = _useArtifacts.workspaceArtifactTree,
    chatExclusiveArtifactTree = _useArtifacts.chatExclusiveArtifactTree,
    allArtifactsTree = _useArtifacts.allArtifactsTree,
    toggleArtifactFolder = _useArtifacts.toggleArtifactFolder,
    handleDownloadArtifact = _useArtifacts.handleDownloadArtifact,
    handlePromoteArtifact = _useArtifacts.handlePromoteArtifact,
    requestArtifactDelete = _useArtifacts.requestArtifactDelete,
    handleArtifactDeleteCancel = _useArtifacts.handleArtifactDeleteCancel,
    handleArtifactDeleteConfirm = _useArtifacts.handleArtifactDeleteConfirm;
  var getFileName = function getFileName(file) {
    return 'name' in file ? file.name : file.fileName;
  };
  var truncateFileName = function truncateFileName(fileName) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;
    if (fileName.length <= maxLength) return fileName;
    var extension = fileName.split('.').pop();
    var name = fileName.slice(0, maxLength - ((extension === null || extension === void 0 ? void 0 : extension.length) || 0) - 3);
    return "".concat(name, "...").concat(extension);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.Content, {
      "data-sentry-element": "Content",
      "data-sentry-source-file": "LocalFilesPanel.tsx",
      children: [selectedFiles.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.AttachedFilesSection, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileListHeader, {
          children: ["Attached files (", selectedFiles.length, ")"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FileList, {
          children: selectedFiles.map(function (file, index) {
            var fileName = getFileName(file);
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileItem, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FileName, {
                title: fileName,
                children: truncateFileName(fileName)
              }), onRemoveFiles && /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
                onClick: function onClick() {
                  return handleRemoveFile(index);
                },
                "aria-label": "Remove file",
                title: "Remove file",
                size: "icon-xs",
                className: "shrink-0"
              })]
            }, index);
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.DropZone, {
          onClick: handleClick,
          onDrop: handleDrop,
          onDragOver: handleDragOver,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FileInput, {
            ref: fileInputRef,
            type: "file",
            accept: ATTACHMENT_ACCEPT,
            multiple: true,
            onChange: handleFileSelect
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.UploadIconWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UploadIcon, {
              width: 20,
              height: 20
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.DropZoneText, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: "Click to add more files"
            })
          })]
        })]
      }), selectedFiles.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "relative flex w-full cursor-pointer flex-col",
        onClick: handleClick,
        onDrop: handleDrop,
        onDragOver: handleDragOver,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FileInput, {
          ref: fileInputRef,
          type: "file",
          accept: ATTACHMENT_ACCEPT,
          multiple: true,
          onChange: handleFileSelect
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fileUploadArea2.FileUploadAreaContext.Provider, {
          value: EMPTY_FILE_UPLOAD_AREA,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fileUploadArea.FileUploadAreaScreen, {})
        })]
      }), !hasWorkspace && artifacts.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.ArtifactsSection, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileListHeader, {
          children: ["Artifacts (", artifacts.length, ")"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactList, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArtifactTreeView, {
            node: allArtifactsTree,
            parentPath: "",
            collapsedFolders: collapsedArtifactFolderPaths,
            onToggleFolder: toggleArtifactFolder,
            recentArtifactIds: recentArtifactIds,
            flashingArtifactIds: flashingArtifactIds,
            onArtifactClick: onArtifactClick,
            downloadingArtifactIds: downloadingArtifactIds,
            onDownloadArtifact: handleDownloadArtifact,
            deletingArtifactIds: deletingArtifactIds,
            onDeleteArtifact: requestArtifactDelete,
            promotingArtifactIds: promotingArtifactIds
          })
        })]
      }), hasWorkspace && workspaceArtifacts.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.ArtifactsSection, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileListHeader, {
          children: ["Workspace artifacts (", workspaceArtifacts.length, ")"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactList, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArtifactTreeView, {
            node: workspaceArtifactTree,
            parentPath: "",
            collapsedFolders: collapsedArtifactFolderPaths,
            onToggleFolder: toggleArtifactFolder,
            recentArtifactIds: recentArtifactIds,
            flashingArtifactIds: flashingArtifactIds,
            onArtifactClick: onArtifactClick,
            downloadingArtifactIds: downloadingArtifactIds,
            onDownloadArtifact: handleDownloadArtifact,
            deletingArtifactIds: deletingArtifactIds,
            onDeleteArtifact: requestArtifactDelete,
            promotingArtifactIds: promotingArtifactIds
          })
        })]
      }), hasWorkspace && chatExclusiveArtifacts.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.ArtifactsSection, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileListHeader, {
          children: ["Chat exclusive artifacts (", chatExclusiveArtifacts.length, ")"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ArtifactList, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArtifactTreeView, {
            node: chatExclusiveArtifactTree,
            parentPath: "",
            collapsedFolders: collapsedArtifactFolderPaths,
            onToggleFolder: toggleArtifactFolder,
            recentArtifactIds: recentArtifactIds,
            flashingArtifactIds: flashingArtifactIds,
            onArtifactClick: onArtifactClick,
            downloadingArtifactIds: downloadingArtifactIds,
            onDownloadArtifact: handleDownloadArtifact,
            deletingArtifactIds: deletingArtifactIds,
            onDeleteArtifact: requestArtifactDelete,
            promotingArtifactIds: promotingArtifactIds,
            onPromoteArtifact: handlePromoteArtifact
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.ManagementSection, {
        "data-sentry-element": "ManagementSection",
        "data-sentry-source-file": "LocalFilesPanel.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.SectionHeader, {
          "data-sentry-element": "SectionHeader",
          "data-sentry-source-file": "LocalFilesPanel.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.SectionTitle, {
            "data-sentry-element": "SectionTitle",
            "data-sentry-source-file": "LocalFilesPanel.tsx",
            children: "Saved files"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.AddButton, {
            onClick: handleAddFile,
            title: "Add file",
            disabled: uploadingFile,
            "data-sentry-element": "AddButton",
            "data-sentry-source-file": "LocalFilesPanel.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {
              width: 16,
              height: 16,
              "data-sentry-element": "AddIcon",
              "data-sentry-source-file": "LocalFilesPanel.tsx"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          ref: addFileInputRef,
          type: "file",
          accept: ATTACHMENT_ACCEPT,
          multiple: true,
          style: {
            display: 'none'
          },
          onChange: handleAddFileSelect
        }), loading || uploadingFile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.LoaderWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {})
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FilesList, {
          children: files.map(function (file) {
            var _userFile$access;
            var managed = isManagedFile(file);
            var userFile = !managed ? file : null;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileListItem, {
              isManaged: managed,
              style: {
                cursor: "default"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileNameWrapper, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FileNameText, {
                  title: file.name,
                  children: truncateFileName(file.name, 35)
                }), managed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.FileTag, {
                  children: "Managed"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalFilesPanel.FileActions, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.HoverActionButton, {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    handleDownloadFile(file);
                  },
                  title: "Download file",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DownloadIcon, {
                    width: 16,
                    height: 16
                  })
                }), userFile !== null && userFile !== void 0 && (_userFile$access = userFile.access) !== null && _userFile$access !== void 0 && _userFile$access.canManageShares ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.HoverActionButton, {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    setFileShareTarget({
                      file: userFile,
                      anchorEl: e.currentTarget
                    });
                  },
                  title: "Share",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ShareIcon, {
                    width: 16,
                    height: 16
                  })
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    width: 24,
                    height: 24,
                    flexShrink: 0
                  },
                  "aria-hidden": "true"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.ActionButton, {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    if (isFileAttached(file.name)) {
                      handleRemoveSavedFile(file.name);
                    } else {
                      handleSelectFile(file);
                    }
                  },
                  title: isFileAttached(file.name) ? "Remove from conversation" : "Add to conversation",
                  style: {
                    backgroundColor: isFileAttached(file.name) ? "#fee2e2" : "#dcfce7",
                    color: isFileAttached(file.name) ? "#dc2626" : "#16a34a"
                  },
                  children: isFileAttached(file.name) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
                    width: 16,
                    height: 16
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {
                    width: 16,
                    height: 16
                  })
                }), (managed ? canManageFiles : (userFile === null || userFile === void 0 ? void 0 : userFile.propelAuthUserID) === (user === null || user === void 0 ? void 0 : user.userId)) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.HoverActionButton, {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    handleDeleteFile(file);
                  },
                  title: managed ? "Delete managed file" : "Delete file",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeleteIcon, {
                    width: 16,
                    height: 16
                  })
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    width: 24,
                    height: 24,
                    flexShrink: 0
                  },
                  "aria-hidden": "true"
                })]
              })]
            }, file.id);
          })
        })]
      })]
    }), fileShareTarget && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResourceSharePopover.ResourceSharePopover, {
      resourceKind: "file",
      resourceId: fileShareTarget.file.id,
      resourceName: fileShareTarget.file.name,
      anchorEl: fileShareTarget.anchorEl,
      access: fileShareTarget.file.access,
      onClose: function onClose() {
        return setFileShareTarget(null);
      }
    }, fileShareTarget.file.id), showDeleteDialog && fileToDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "destructive",
      title: "Confirm delete",
      message: fileToDelete.managed ? "Are you sure you want to delete the managed file \"".concat(fileToDelete.file.name, "\"? This will remove it for all users.") : "Are you sure you want to delete \"".concat(fileToDelete.file.name, "\"?"),
      confirmLabel: "Delete",
      onCancel: handleDeleteCancel,
      onConfirm: handleDeleteConfirm
    }), artifactAwaitingDeleteConfirmation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "destructive",
      title: "Delete artifact",
      message: "Delete artifact \"".concat(artifactAwaitingDeleteConfirmation.name, "\"? This removes the stored file and cannot be undone."),
      confirmLabel: "Delete",
      onCancel: handleArtifactDeleteCancel,
      onConfirm: handleArtifactDeleteConfirm
    })]
  });
};